import _ from "lodash";
import React from "react";
import { Navigate } from "react-router-dom";

import {
  getLocalStorageAuth,
  getLocalStorageUserProfile,
} from "@utils/localStorage";

export const PrivateRoute = ({ children, permission }) => {
  const auth = getLocalStorageAuth();
  const userProfile = getLocalStorageUserProfile();
  const userPermission = _.get(userProfile, ["role", "permissions"]);
  if (auth) {
    if (_.includes(userPermission, permission)) {
      return children;
    } else {
      return <Navigate to={"/no-access"} />;
    }
  } else {
    return <Navigate to={"/"} />;
  }
};
